import { useState, useEffect } from 'react';
import { Loader2, AlertTriangle, FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { diagnosticsAPI } from '../../lib/api';

const STATUS_BADGE_VARIANT = {
  stored: 'default',
  pending: 'secondary',
  failed: 'destructive',
};

export function ReceiptIngestSummaryCard() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    diagnosticsAPI.receiptIngestSummary()
      .then(({ data: d }) => { if (!cancelled) setData(d); })
      .catch((err) => { if (!cancelled) setError(err.message || 'Failed to fetch receipt ingest summary'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const counts = data ? data.counts_by_status : {};
  const statuses = Object.keys(counts).sort();

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <FileText className="h-4 w-4 text-muted-foreground" />
          <CardTitle className="text-lg">Receipt Ingest (Chief of Staff)</CardTitle>
          {data && (
            <Badge variant="secondary" className="text-xs ml-auto">
              {data.total} total
            </Badge>
          )}
        </div>
        {data && (
          <p className="text-xs text-muted-foreground">
            Last ingest: {data.last_ingest_at ? new Date(data.last_ingest_at).toLocaleString() : 'never'}
          </p>
        )}
      </CardHeader>
      <CardContent>
        {loading && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            Loading...
          </div>
        )}
        {error && (
          <div className="flex items-center gap-2 text-sm text-red-500">
            <AlertTriangle className="h-4 w-4" />
            {error}
          </div>
        )}
        {data && statuses.length === 0 && (
          <div className="text-sm text-muted-foreground">No direct receipt ingests recorded yet.</div>
        )}
        {data && statuses.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {statuses.map((status) => (
              <Badge key={status} variant={STATUS_BADGE_VARIANT[status] || 'secondary'} className="text-xs">
                {status}: {counts[status]}
              </Badge>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
